import { EffectiveRoleViewAuthorizationService } from '../authorization/service';
import { FeatureFlagsService } from '../featureflags/service';

export class FeatureAccessService {
  /** Use this to decide feature access for a given role based on combination of
   * enabled-features-service and user permissions
   */

  constructor(
    readonly featureFlagsService: FeatureFlagsService,
    readonly authorizationService: EffectiveRoleViewAuthorizationService
  ) {}

  public canViewUserPermissions = () => {
    return (
      this.featureFlagsService.isPermissionsUiEnabled() &&
      this.authorizationService.canReadUserPermissions()
    );
  };

  public canWriteUserPermissions = () => {
    //TODO: Valentin permisisons - shouldn't this be canWriteUserPermisions()?
    return (
      this.featureFlagsService.isPermissionsUiEnabled() &&
      this.authorizationService.canReadUserPermissions()
    );
  };

  public canViewRoleSettings = () => {
    if (this.featureFlagsService.isCrextaPermissionsView()) {
      return false;
    } else {
      return (
        this.featureFlagsService.isPermissionsUiEnabled() &&
        this.authorizationService.canReadRoleSettings()
      );
    }
  };

  public canWriteRoleSettings = () => {
    if (this.featureFlagsService.isCrextaPermissionsView()) {
      return false;
    } else {
      return (
        this.featureFlagsService.isPermissionsUiEnabled() &&
        this.authorizationService.canWriteRoleSettings()
      );
    }
  };
  /**
   * Determines whether the user can view datapipeline DAG information
   * Only superadmins (users who can read role settings) should see this technical detail
   */
  public canViewDatapipelineDag = () => {
    return this.authorizationService.canManageThisDomain();
  };
}
